import { ChatAdapterOptions, StandardChatAdapter } from './langchain';
import { useDeepCompareEffect } from '@nlux/react';
import { useState } from 'react';
import { getAdapterBuilder } from './getAdapterBuilder';
import { ExtendedChatAdapterOptions } from './langchain/langgraph/types/adapterOptions';

export const useChatAdapter = <AiMsg = string>(
  options: ExtendedChatAdapterOptions<AiMsg>
): StandardChatAdapter<AiMsg> => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [adapter, setAdapter] = useState<StandardChatAdapter<AiMsg>>(
    getAdapterBuilder<AiMsg>(options).create()
  );

  const {
    url,
    dataTransferMode,
    headers,
    config,
    inputPreProcessor,
    outputPreProcessor,
    useInputSchema,
    mapActionsProcessor,
  } = options || {};

  useDeepCompareEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }

    const newAdapter = getAdapterBuilder<AiMsg>(options).create();
    setAdapter(newAdapter);
  }, [
    isInitialized,
    url,
    dataTransferMode,
    headers || {},
    config || {},
    inputPreProcessor,
    outputPreProcessor,
    useInputSchema,
    mapActionsProcessor,
  ]);

  return adapter;
};
